/* eslint-disable @typescript-eslint/indent */
import React, { Dispatch, SetStateAction, useContext } from 'react';
import HotelDetails from '@customTypes/hotel-details';
import { CartItemDetails } from '@customTypes/cart-items';
import { getDetailedDate } from '@helpers/date';
import BottomDrawerVariant from '@components/common/BottomDrawer/BottomDrawerVariant';
import Product from '@customTypes/product';
import { store } from '@context/store';
import ProductDetailsCardFactory from './ProductDetailsVariant/Components/ProductDetailsCardFactory';
import ProductBannersFactory from './ProductDetailsVariant/Components/ProductBannersFactory';
import ProductComponentWithImage from './ProductComponentWithImage';

type Props = {
  cartData: CartItemDetails | undefined;
  date: Date | undefined;
  hotelDetails: HotelDetails;
  product: Product;
  products: Product[] | undefined;
  setCartData: Dispatch<SetStateAction<CartItemDetails | undefined>>;
  loadingProducts: boolean;
  isBottomDrawerOpen: boolean;
  setIsBottomDrawerOpen: Dispatch<SetStateAction<boolean>>;
  showFairPricing: boolean;
};

export default function MobileProductDetails({
  cartData,
  date,
  loadingProducts,
  hotelDetails,
  product,
  products,
  setCartData,
  isBottomDrawerOpen,
  setIsBottomDrawerOpen,
  showFairPricing,
}: Props) {
  const { state } = useContext(store);
  const { selectedTimeSlot } = state;
  const currentProduct = selectedTimeSlot
    ? { ...selectedTimeSlot, is_product_time_group: false }
    : product;

  return (
    <>
      <ProductComponentWithImage
        product={product}
        products={products}
        date={date}
        cartData={cartData}
        hotelDetails={hotelDetails}
        showFairPricing={showFairPricing}
        setIsBottomDrawerOpen={setIsBottomDrawerOpen}
      />

      {isBottomDrawerOpen ? (
        <BottomDrawerVariant
          setIsOpen={setIsBottomDrawerOpen}
          isOpen={isBottomDrawerOpen}
          title={product.name}
          subTitle={date && getDetailedDate(date)}
          isBehind
          childrenClasses="pb-100px"
          key={`modal-product-detail-${product.product_id}`}
        >
          <>
            <ProductBannersFactory
              cartData={cartData}
              date={date}
              hotelDetails={hotelDetails}
              product={currentProduct}
              loadingProducts={loadingProducts}
            />

            <ProductDetailsCardFactory
              showFairPricing={showFairPricing}
              cartData={cartData}
              date={date}
              hotelDetails={hotelDetails}
              product={product}
              setCartData={setCartData}
              setIsDrawerOpen={setIsBottomDrawerOpen}
            />
          </>
        </BottomDrawerVariant>
      ) : null}
    </>
  );
}
